export default {
  firebaseConfig: {
    apiKey: 'AIzaSyDS4u5G8rj8kDx-zYxgd8Wi2YIfLvVCta4',
    authDomain: 'casstack-sale-booster-platform.firebaseapp.com',
    databaseURL: 'https://casstack-sale-booster-platform.firebaseio.com',
    projectId: 'casstack-sale-booster-platform',
    storageBucket: 'cdn.casstack.com',
    messagingSenderId: '956730245551',
    appId: '1:956730245551:web:5546ed25d8f5b4fc6baf5a',
    measurementId: 'G-FRQ43ZHXCX'
  }
}
